import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@/services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const accessToken = authService.accessToken();

  let headers = req.headers;

  if (!headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }

  if (accessToken) {
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return next(req.clone({ headers, withCredentials: true }));
};
